/**
 * "How a day is judged" as one quiet line that opens the animated story
 * on demand (user, 13/10/2026: the tab must read clean — the story is
 * there for whoever wants it, never in the way).
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC, ReactNode, useState } from 'react';
import { ChevronRight } from 'lucide-react';

import { cn } from '@/lib/utils';

export const HowJudged: FC<{ children: ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <div data-testid="how-judged">
      <button
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1 text-xs font-medium text-muted-foreground transition-colors hover:text-foreground"
      >
        <ChevronRight className={cn('h-3.5 w-3.5 transition-transform duration-200', open && 'rotate-90')} aria-hidden />
        How a day is judged
      </button>
      {open ? <div className="mt-2 duration-300 animate-in fade-in-0 slide-in-from-top-1 motion-reduce:animate-none">{children}</div> : null}
    </div>
  );
};
